import { SagaIterator } from 'redux-saga';
import { all, put, takeLatest, call } from 'redux-saga/effects';
import { AnnouncementActionTypes } from 'types';
import {
  getListAnnouncementsSuccess,
  getListAnnouncementsFailure
} from './actions';
import { getListAnnouncements } from 'services/announcement.service';
import { isAxiosError } from 'axios';

function* handleGetListAnnouncements(request: any): SagaIterator {
  try {
    const response = yield call(getListAnnouncements, request.payload);
    if (response?.error) {
      return yield put(getListAnnouncementsFailure(response.error.message));
    }

    if (response?.data?.Notices) {
      yield put(getListAnnouncementsSuccess(response.data.Notices));
    } else {
      yield put(getListAnnouncementsFailure('Unable to get announcement'));
    }
  } catch (err) {
    let errMsg = 'Something went wrong';

    if (isAxiosError(err)) {
      errMsg = err.response?.data?.error?.message || err.message || errMsg;
    }

    yield put(getListAnnouncementsFailure(errMsg));
  }
}

function* watchGetListAnnouncements() {
  yield takeLatest(
    AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_START,
    handleGetListAnnouncements
  );
}

function* AnnouncementsSagas() {
  yield all([call(watchGetListAnnouncements)]);
}

export default AnnouncementsSagas;
